<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .live{
    /*width: 1200px;*/
    /*margin: 0 auto;*/
    background: url("../assets/img/bg.png")no-repeat;
    background-position-y:bottom;
    width: 100%;
    overflow: hidden;
  }
  .live .nav{
    background:url('../assets/img/navbg.png')no-repeat;
    width: 1530px;
    height: 110px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .live .nav img{
    float: left;
    margin-left: 160px;
    margin-top: 35px;
  }
  .live .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .live .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 120px;
    text-align: center;
    line-height: 110px;
    color: #ebbfbf;
    font-size: 16px;
    font-weight: 900;
    cursor: pointer;
    position: relative;
  }
  .live .nav ul li span{
    position: absolute;
    left: 0;
    bottom: -25px;
    text-align: center;
    width: 100%;
    font-weight: 100;
  }
  .live .nav ul li:hover{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .live .nav ul li.on{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .live .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .live .content {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 195px;
  }
  .live .content .title{
    margin-top: 100px;
    color: #ffffff;
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 30px;
  }
  .live .content .title img{
    margin-right: 15px;
  }
  .live .content .text1{
    min-height: 300px;
  }
  .live .content .text1 ul{
    overflow: hidden;
    width: 300px;
    margin: 0 auto;
  }
  .live .content .text1 ul li {
    float: left;
    width: 250px;
  }
  .live .content .text1 ul li img{
    width: 100%;
  }
</style>
<template>
  <div class="live">
    <myhead></myhead>
    <nav class="nav">
      <img src="../assets/img/logo.png" alt=""/>
      <ul>
        <li @click="urlFun('/Home')"> 首页 <span>Home</span></li>
        <li @click="urlFun('/news')">新闻<span> News</span></li>
        <li @click="urlFun('/rules')">规则<span> Rule</span></li>
        <li @click="urlFun('/match')">赛程<span>Schedule</span></li>
        <!--<li @click="urlFun('/videoList')">视频<span>Video</span></li>-->
        <li @click="urlFun('/stadium')">场馆<span>Venue</span></li>
        <li class="on" @click="urlFun('/live')">直播<span> Live</span></li>
      </ul>
      <div class="btn" @click="urlFun('/signUp')"></div>
    </nav>
    <div class="content">
      <div class="title"><img src="../assets/img/title.png" alt=""/>赛事直播</div>
      <div class="text1">
        <ul>
          <li>
            <img src="../assets/img/douyu_logo.png">
          </li>
          <!--<li>-->
            <!--<img src="../assets/img/Huya-LOGO.png">-->
          <!--</li>-->
          <!--<li>-->
            <!--<img style="margin-top: 21px;" src="../assets/img/qielogo.png">-->
          <!--</li>-->
        </ul>
      </div>
    </div>
    <mybottom></mybottom>
  </div>
</template>

<script>
    import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  export default {
    name: 'Rules',
    components: {
      mybottom,
      myhead
    },
    data () {
      return {

      }
    },

    computed:{

    },
    mounted(){

    },
    methods:{
      urlFun(url){
        this.$router.push({path:url})
      },

    },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Live.vue